export default __webpack_public_path__ + "assets/front/scss/affichage-liste.bd7c8ee6e81deadccd7a40a100b2b820.css";